import { useState } from 'react';
import { useSelector } from 'react-redux';
import {
  Bar,
  Brush,
  ComposedChart,
  LabelList,
  Legend,
  Line,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';
import { MaskValor } from '../../../../../component';
import { IChartProps, StickyTooltip } from '../../../../../component/charts';
import ChartCard from '../../../../../component/charts/chartCard';
import {
  labelFormatterNumber,
  labelFormatterPercentile,
} from '../../../../../shared/formatters/formatters';
import { AdsPerExistingRealtiesChartData } from './types';

export const AdsPerExistingRealties: React.FC = () => {
  const { requestStatusSecondary } = useSelector(
    (state: any) => state.offersSecondaryState
  );
  const { chartsDataSecondary } = useSelector(
    (state: any) => state.offersSecondaryState
  );
  return (
    <ChartCard
      data={chartsDataSecondary['ads_per_existing_realties']}
      Chart={AdsPerExistingRealtiesChart}
      cy={'AdsPerExistingRealties'}
      id={'adsPerExistingRealties'}
      requestStatus={requestStatusSecondary['adsPerExistingRealties']}
      hasAnnualDataOnly
    />
  );
};

const AdsPerExistingRealtiesChart: React.FC<
  IChartProps<AdsPerExistingRealtiesChartData[]>
> = ({ data, cy, id }) => {
  data = data?.map((el: any) => ({
    ...el,
    ose_subtitle: Number(el.ose_subtitle),
  }));
  const { average_realties_announced_over_existing_realties } = useSelector(
    (state: any) => state.offersSecondaryState.chartsDataSecondary
  );
  const [hasClicked, setHasClicked] = useState<boolean>(false);
  const [recordTooltip, setRecordTooltip] = useState<JSX.Element | null>(null);
  const [stopChange, setStopChange] = useState<boolean>(false);
  const formatterFunctions = [
    labelFormatterNumber,
    labelFormatterPercentile,
    labelFormatterPercentile,
  ];
  const average = average_realties_announced_over_existing_realties;
  return (
    <ResponsiveContainer
      data-cy={`RealtyAnnouncedOverExisting${cy}`}
      width="99%"
      height="100%"
    >
      <ComposedChart
        id={id}
        data={data}
        margin={{
          top: 20,
          right: 30,
          left: 20,
          bottom: 5,
        }}
        onClick={() => setHasClicked(!hasClicked)}
      >
        <XAxis dataKey="id" />
        <YAxis
          yAxisId="left"
          orientation="left"
          stroke="#8884d8"
          padding={{ top: 40 }}
        />
        <YAxis
          yAxisId="right"
          orientation="right"
          stroke="#492273"
          tickFormatter={(tick) => `${tick}%`}
        />
        <Legend iconType="circle" />
        <Tooltip
          wrapperStyle={{ visibility: 'visible' }}
          content={
            <StickyTooltip
              hasClicked={hasClicked}
              recordTooltip={recordTooltip}
              setRecordTooltip={setRecordTooltip}
              stopChange={stopChange}
              setStopChange={setStopChange}
              formatterFunctions={formatterFunctions}
            />
          }
        />
        <Bar
          isAnimationActive={false}
          yAxisId="left"
          name="Existentes"
          dataKey="value"
          fill="#8884d8"
        >
          <LabelList
            dataKey="value"
            position="top"
            formatter={(v: any) => MaskValor(v)}
          />
        </Bar>
        <Bar
          isAnimationActive={false}
          yAxisId="right"
          name="A.S.E"
          dataKey="ose_subtitle"
          fill="#492273"
        >
          <LabelList
            dataKey="ose_subtitle"
            position="top"
            formatter={(v: any) => `${v}%`}
          />
        </Bar>
        <Line
          isAnimationActive={false}
          yAxisId="right"
          dataKey={() => average}
          name="Média de anúncios sobre existentes"
          stroke="red"
        />
        <Brush dataKey="id" height={30} stroke="#8884d8" />
      </ComposedChart>
    </ResponsiveContainer>
  );
};
